// extracted by mini-css-extract-plugin
module.exports = {"label":"CheckboxItem_label__LbXII","checkbox":"CheckboxItem_checkbox__1EBRM"};